export default "__VITE_ASSET__DmWUAluZ__"